module.exports = __webpack_public_path__ + "static/media/Skim_profile.f33169e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PersonalImages/Skim_profile.png
// module id = 337
// module chunks = 0